<template>
  <div class="square">
      <div style="overflow:hidden;margin-top:30px;padding-left: 20px;">
      <div class="blue"></div>
      <p class="title">视频广场</p>
      <router-link to="/videoList.html">
        <p class="more">更多></p>
      </router-link>
    </div>
    <div class="video-part" >
      <div
        class="video-img"
        v-for="(item,index) in story" :key="index"
        @click="playVideo(item)"
      >
        <img :src="item.imageUrl" alt />
        <p class="img-title">{{item.title}}</p>
        <!-- <p class="img-sum">{{item.summary}}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      story: [],
    };
  },
  mounted() {
    this.gethomevideo();
  },
  methods: {
    gethomevideo() {
      this.axios
        .get("/api/consume/information/videohome", {
          params: {
            num: 4
          }
        })
        .then(res => { 
            if(res.status ==200) {
                // console.log(res)      
                this.story = res.data;
            }  
        });
    },
    playVideo(val) {
       localStorage.setItem("videoList", JSON.stringify(val))
      this.$router.push({
        path: `/video.html`,
        // query: {
        //   id: val,
        //   PageIndex: this.number,
        //   // videoList: JSON.stringify(arr[0]),
        //   index: index
        // }
      });
    },
  }
};
</script>

<style>
.square {
  background: #fff;
}

.square .title {
  font-size: 32px;
  color: #282828;
  font-weight: bold;
  float: left;
  margin-left: 22px;
}
.square .more {
  float: right;
  font-size: 22px;
  margin-right: 35.5px;
  line-height: 44px;
  color: #666;
}
.square .video-part {
  background: #fff !important;
  overflow: hidden;
  /* margin-top: 10px; */
  padding: 0 13.5px;
}
.square .blue {
  width: 6px;
  height: 30px;
  background: #64b3f1;
  float: left;
  margin-top: 5px;
  /* margin-left: 22px; */
}
.square .title {
  font-size: 32px;
  color: #282828;
  font-weight: bold;
  float: left;
  margin-left: 22px;
}
.square .video-img {
  width: 334px;
  float: left;
}
.square .video-img:nth-child(even) {
  margin-left: 20px;
}
.square .video-img img {
  width: 334px;
  height: 198px;
  margin-left: 21px;
  margin-top: 35px;
}
.square .img-title {
  margin-left: 22px;
  font-size: 26px;
  color: #444;
  width: 334px;
  height: 76px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.square .img-sum {
  margin-left: 22px;
  font-size: 22px;
  color: #8b8b8b;
  margin-top: 19px;
}

</style>



// WEBPACK FOOTER //
// src/components/SquareVideo.vue